import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const EXECUTE_SEARCH = USER_ROOT_API_URL + "/execute_search";
export const EXECUTE_SEARCH_BY_DATE = USER_ROOT_API_URL + "/search_by_date";
